var copy = require('./extend');
var _util = require('./_util');
var reqMultipart = 'multipart/form-data;charset=UTF-8';
var userInfo = {}
var passport_host_v1 = '';
var passport_host_v2 = '';
var cg_host_v1 = '';
var cg_host_v2 = '';
var logHost = '';
var ucresHost = '';
var captchaContent = '';   // 图形验证码插入的父级元素
var __udc_ctx = ''; // 微信授权参数
// 所有调用接口统一为https协议
var getProtocol = 'https:'
window.SET_APP_TAL_TOKEN = ''
// 获取环境判断
var getJudgeEnv = process.env.JUDGE_ENV || ''
// 滑块是否二次验证
window.ALI_AWSC_TRIGGE_NC = 0

// cdn外链sdk的情况下设置接口域名
var qrCodeBoxNode, startShow;

var domain = 'xueersi.com'

var slideCallback, slideParams, slidefailCallback, isH5, captchaLoding = false, configNVCInitParams = {};

function getParams(params) {
    return _util.getParams(params)
}

// 设置域名
function setRequestDomainVar (env, domain, entity) {
  var getAllVar = _util.setRequestDomain(env, domain, entity)
  passport_host_v1 = getAllVar.passport_host_v1
  passport_host_v2 = getAllVar.passport_host_v2
  cg_host_v1 = getAllVar.cg_host_v1
  cg_host_v2 = getAllVar.cg_host_v2
  ucresHost = getAllVar.ucresHost
}

var checkHeartbeatFlag = '',
    setHeartbeatFlag = '',
    intervalNum = null,
    intervalRenderDomNum = null

var TAL_UC = {
    /*
    * @discribe 用户注入方法
    * 都要写在这个方法之中
    * @method ready
    * @param {Function} 匿名函数方法
    * */
    rankConfig: function(options) {
        var newOptions = {
            'client-id': options['client-id'] || ''
        };
        if (options.captchaContent) {
            captchaContent = options.captchaContent
        }
        userInfo = copy.extend(true, {}, userInfo, newOptions)
        // console.log(ucresHost,'-----ucresHost')
        if (options.env) {
            setRequestDomainVar(options.env, options.domain, options.entity)
        } else {
          setRequestDomainVar(getJudgeEnv, options.domain, options.entity)
        }
        _util.setHeader(userInfo, options.domain, ucresHost, options)
        // console.log(ucresHost,'ucresHost-----')
        // 设备信息上报机制升级，0-6点首次、6-12点首次、12-18点首次、18-24首次
        // 获取上一次上报设备信息的日期
        var upLoadTime = _util.resetLocalStorage.getItem('tal-passport-upLoad-deviceInfo-timeStamp') || ''
        if (upLoadTime) {
            // 并非首次上传，之前上传过，判断该时间是否在当天的上报时间段，时间与当前时间在同一天，判断时间段，不在同一天即时上报即可
            // 获取当前时间日期
            var currentDate = _util.getCurrentDate(),
                // 上次上报的日期
                lastUpLoadDate = _util.timestampToDate(parseFloat(upLoadTime))
            // 如果上一次上报的日期与当前日期在同一天，判断小时数是否在相同的时间段，在同一时间段不上报，否则上报并且修改上一次的存储上报时间为当前时间戳
            if (lastUpLoadDate.date == currentDate.date) {
                // 上一次上报是在当天时间，判断上一次上报的时间和当前时间是否在同一个上报时间段内，在不作处理，否则上报，并且修改上一次存储的上报时间为当前时间戳
                var lastHours = lastUpLoadDate.hours,
                    currentHours = currentDate.hours
                if ((lastHours >= 0 && lastHours < 6 && currentHours >= 6) || (lastHours >= 6 && lastHours < 12 && currentHours >= 12) || (lastHours >= 12 && lastHours < 18 && currentHours >= 18) || (lastHours >= 18 && lastHours < 24 && currentHours < 18)) {
                    // 上报一次
                    _util.upLoadDeviceInfoFn(ucresHost, passport_host_v1)
                }

            } else {
                // 上一次上报时间并非当天时间，当天一定是第一次，直接上报即可
                _util.upLoadDeviceInfoFn(ucresHost, passport_host_v1)
            }

        } else {
            // 不存在说明之前没有上报该信息，上报并且存储上报时间
            _util.upLoadDeviceInfoFn(ucresHost, passport_host_v1)
        }

        /******设置心跳逻辑处理*********/
        var _t = this
        // 设置心跳时间
        var setHeartbeatTime = 5 * 60 * 1000
        // 心跳逻辑处理方法
        function setHeartbeat(){
          // 首先判断是否存在登录态，存在才启动心跳逻辑，每次轮询都是相同的逻辑
          _t.asyncCheckLogin().then(function(res){
            // 获取上一次心跳执行时间
            var prevTimeStamp = (_util.isHttpProtocol() ? _util.getCookieValue('tal-passport-run-heartbeat-timeStamp') : _util.resetLocalStorage.getItem('tal-passport-run-heartbeat-timeStamp')) || 0,
                // 毫秒级时间戳
                curTimeStamp = new Date().getTime(),
                timeDiff = curTimeStamp - prevTimeStamp,
                lastTimeStamp = (setHeartbeatTime - timeDiff) > 0 ? (setHeartbeatTime - timeDiff) : setHeartbeatTime,
            lastTimeStamp = lastTimeStamp > setHeartbeatTime ? setHeartbeatTime : (lastTimeStamp < 0 ? 0 : lastTimeStamp)
            console.log(lastTimeStamp,'==lastTimeStamp===')
            // 判断timeDiff是否大于5min，如果大于5min就按照5min计算，负数就按照0计算
            if (lastTimeStamp < setHeartbeatTime) {
              console.log('延迟加载========')
              // 避免重复请求心跳，如果存在上一次先清除
              if (window.tal_passport_checkopen_isheartbeat) {
                  window.clearTimeout(window.tal_passport_checkopen_isheartbeat)
              }
              // 延迟 lastTimeStamp 毫秒之后执行心跳
              window.tal_passport_checkopen_isheartbeat = window.setTimeout(setHeartbeat, lastTimeStamp)
            } else {
              console.log('存储====')
              // 立即执行心跳，本地存储执行心跳时间，为了开两个窗口同时请求两次心跳接口，但可能会存在接口响应时间段的误差
              var _domains = ["com","net","org","gov","cn","com\\.cn","net\\.cn","org\\.cn","gov\\.cn","[a-z]{2}\\.cn","vip","tech","tv","co","live","xyz","top","info","mobi","group","中国"]
              var _str = _domains.join("|")
              var _pattern = new RegExp("[\\w-_]+\\.(" + _str + ")$","i")
              var _res = _pattern.exec(options.domain)
              _res = _res || []
              if (!_res[0]) {
                // 定级域名不合法
                console.log('******------域名不在合法的范围内------******')
              }
              // 判断是否为http/https协议，是执行cookie存储，否则执行localStorage存储，目的为了解决非http/https协议下无法存储cookie问题
              if (_util.isHttpProtocol()) {
                // http/https协议
                _util.setCookieValue('tal-passport-run-heartbeat-timeStamp', new Date().getTime(), _res[0])
              } else {
                // 非http/https协议
                _util.resetLocalStorage.setItem('tal-passport-run-heartbeat-timeStamp', new Date().getTime())
              }
              // 执行心跳方法，心跳方法执行完成之后重新启动5min的轮询setHeartbeat方法
              _t.checkHeartbeat({
                  complete: function(resData) {
                      // 当错误码为 11100-11199 时，未登录或者登录失效，不启动心跳5分钟轮询
                      if (resData.errcode || resData.errcode == 0) {
                          var getErrcode = parseInt(resData.errcode)
                          if (getErrcode >= 11100 && getErrcode <= 11199) return false
                      }
                      // 避免重复请求心跳，如果存在上一次先清除
                      if (window.tal_passport_setheartbeat_flag) {
                          window.clearTimeout(window.tal_passport_setheartbeat_flag)
                      }
                      // 成功之后5分钟请求一次心跳接口
                      window.tal_passport_setheartbeat_flag = window.setTimeout(setHeartbeat, setHeartbeatTime)
                  }
              })
            }
          }).catch(function(err){
            console.log('haode======err')
            // 避免重复请求心跳，如果存在上一次先清除
            if (window.tal_passport_heartbeat_checkLogin_flag) {
                window.clearTimeout(window.tal_passport_heartbeat_checkLogin_flag)
            }
            // 未登录，不存在登录态时，10s之后重新启动心跳逻辑，避免checkLogin接口处于心跳时期接口因网络等特殊原因突然造成失败，后续恢复正常之后没有心跳问题
            window.tal_passport_heartbeat_checkLogin_flag = window.setTimeout(setHeartbeat,  10 * 1000)
          })
        }
        // 判断是否有登录态，决定开启心跳机制
        _t.asyncCheckLogin().then(function(res){
          // 已登录，存在登录态，立即开启心跳
          setHeartbeat()
        }).catch(function(err){
          // 初始化时未登录状态，开启一个5分钟的定时任务，轮询登录状态，直到存在登录态时清除任务定时器，正常开启心跳逻辑
          var setCheckLoginTimer_flag = setInterval(function(){
            _t.asyncCheckLogin().then(function(res){
              // 已登录，存在登录态，清除定时任务setCheckLoginTimer_flag，同时开启正常心跳逻辑
              window.clearInterval(setCheckLoginTimer_flag)
              setHeartbeat()
            }).catch(function(err){
              // 不存在登录态，不做任何处理
            })
          }, 5 * 60 * 1000)
        })
        // 设置资源错误系统日志
        // _util.sysLog(logHost)
        // 上报设备信息
        // _util.upLoadDeviceInfo(passport_host_v1+ '/web/config/init')
    },
    /*
    * @discribe 用户获取一些header头基本信息的方法
    * @method getNeedInfo
    * @param {Function} 匿名函数方法
    * @return {Object} 返回一个对象
    * */
    getDeviceInfo(params) {
        params.success({
            errcode: 0,
            errmsg: '请求成功',
            data: {
                "device-id": _util.createdDeviceId()
            }
        });
    },
    /*
    * @discribe 初始化无痕验证。
    * @method configNVC
    * @param {params} 登录参数
    * @return {Boolean} 返回一个Promise对象 startPollingQRCodeStatus
    * */
    configNVC: function(configParams) {
        // 证明调用了滑块
        window.TAL_UC_PASSPORT_CONFIG_NVC_INIT = this.configNVCInit(configParams)
    },
    /*
    * @discribe 异步执行滑块。
    * @method configNVC
    * @param {params} 登录参数
    * @return {Boolean} 返回一个Promise对象 startPollingQRCodeStatus
    * */
    configNVCInit: function(configParams) {
        var _this = this
        configNVCInitParams = configParams || {}
        return new Promise(function(resolve, rejec) {
            var scene, appkey;
            // 初始化无痕验证
            if (configParams.isH5) {
                // H5页面
                scene = 'nvc_login_h5';
                isH5 = true;
                appkey = 'FFFF0N00000000007DA2';
            } else {
                // web页面
                scene = 'nvc_login';
                isH5 = false;
                appkey = 'FFFF0N00000000007DA2';
            }
            var script = document.createElement('script')
            script.type = 'text/javascript'
            script.src = getProtocol + '//g.alicdn.com/AWSC/AWSC/awsc.js'
            document.getElementsByTagName('head')[0].appendChild(script)
            var timer = 0;
            script.onload = function() {
              if (typeof AWSC && typeof AWSC === 'object') {
                // 实例化nvc 对无痕验证进行初始化操作
                AWSC.use("nvc", function (state, module) {
                  // 初始化 调用module.init进行初始化
                  window.ALI_AWSC_INIT_NVC = module.init({
                    // 应用类型标识。它和使用场景标识（scene字段）一起决定了无痕验证的业务场景与后端对应使用的策略模型。您可以在阿里云验证码控制台的配置管理页签找到对应的appkey字段值，请务必正确填写。
                    appkey: appkey,
                    //使用场景标识。它和应用类型标识（appkey字段）一起决定了无痕验证的业务场景与后端对应使用的策略模型。您可以在阿里云验证码控制台的配置管理页签找到对应的scene值，请务必正确填写。
                    scene: scene,
                    // 二次验证获取人机信息串，跟随业务请求一起上传至业务服务器，由业务服务器进行验签。
                    success: function (data) {
                        slideParams.data.invisible_sig = data
                        slideParams.data.is_second_verify = 1
                        if (_this[slideCallback]) {
                            _this[slideCallback](slideParams)
                        } else {
                            slidefailCallback({ errcode: 4000, errmsg: '方法名错误' })
                        }
                    },
                    // 前端二次验证失败时触发该回调参数
                    fail: function (failCode) {
                    },
                    // 前端二次验证加载异常时触发该回调参数。
                    error: function (errorCode) {
                    }
                  });
                });
                configParams.onloadCallback ? configParams.onloadCallback() : '';
                resolve({ status: 'success' })
              } else {
                  timer = setInterval(function() {
                      if (typeof AWSC && typeof AWSC === 'object') {
                          clearInterval(timer)
                          configParams.onloadCallback ? configParams.onloadCallback() : '';
                          resolve({ status: 'success' })
                      }
                  }, 5)
              }
            };
            script.onerror = function() {
                configParams.failCallback ? configParams.failCallback : '';
                resolve({ status: 'fail' })
            }
        })
    },
    /*
    * @discribe 验证当前状态是否可以直接登录，如果可以使用快捷token登录，无需用户输入账号密码
    * @method checkToken
    * @param {params} 登录参数
    * @return {Boolean} 返回一个Promise对象
    * */
    checkToken: function(params) {
        if (!_util.validResHeader()) return params.success(_util.getCode(1000000))
        var setParams = {
            data: params.data || {},
            success: function(res) {
                // passport登录成功存在一个开启心跳的标识，存在localStorage本地存储中
                if (res.errcode == 0) {
                    _util.resetLocalStorage.setItem("tal-passport-open-heartbeat-tag", true);
                }
                // 调取传递的回调方法
                params.success ? params.success(res) : function(res) { }

            },
            fail: function(fail) {
                params.fail ? params.fail(fail) : function(fail) { }
            },
            complete: function(res) {
                params.complete ? params.complete(res) : function(res) { }
            }
        }
        // 判断Js-Bridge是否存在Tal-Token，如果存在设置Tal-Token字段header头，不存在不设置该字段，执行之前的逻辑，此逻辑针对h5在APP内调用起作用
        var setRequestHeaderArr = []
        if (!window.SET_APP_TAL_TOKEN) {
          // 向app发送获取token的请求
          try {
            window.SET_APP_TAL_TOKEN =   window.talAccSDKJSBridge.getTalToken()
          } catch(err) {
            try {
              window.SET_APP_TAL_TOKEN = window.talAccSdk.TALAccSDKGetTalTokenJSMsgHandler('GET_APP_TAL_TOKEN')
            } catch(err) {
              console.log('web网页')
            }
          }
        }
        console.log(window.SET_APP_TAL_TOKEN,'==SET_APP_TAL_TOKEN==')
        // 判断是否在APP下获取到tal-token
        if (window.SET_APP_TAL_TOKEN) {
          setRequestHeaderArr.push({
            fieldName: 'Tal-Token',
            fieldValue: window.SET_APP_TAL_TOKEN || ''
          })
        } else {
          console.log(window.SET_APP_TAL_TOKEN,'====window.4567890======')
        }
        var setSpecialParams = {
           addHeaders: setRequestHeaderArr
        }
        _util.axiosPost(passport_host_v1 + '/web/login/token', setParams, setSpecialParams)
    },

    /*
    * @discribe 验证当前状态是否可以直接登录，如果可以使用快捷token登录，无需用户输入账号密码
    * @method tokenLogin
    * @param {params} 登录参数
    * @return {Boolean} 返回一个Promise对象
    * */
    tokenLogin: function(params) {
        this.checkToken(params)
    },

    /*
    * @discribe 校验登录态
    * @method checkLogin
    * @param {params} 登录参数
    * */
    checkLogin: function(params) {
      if (!_util.validResHeader()) return (params.success ? params.success(_util.getCode(1000000)) : '')
      var privateParams = getParams(params)
      // 判断是否存在本地缓存sessionStorage tal-passport-jssdk-tal-token字段
      var getSessionStorageTalToken = _util.resetSessionStorage.getItem('tal-passport-jssdk-tal-token') || ''
      console.log(getSessionStorageTalToken,'==getSessionStorageTalToken==')
      if (getSessionStorageTalToken) {
        // 如果存在，则表示已经登录，直接返回errcode为0， errmsg为'您已登录'，不再请求校验登录态接口
        var res = {
          errcode: 0,
          errmsg: '您已登录',
          data: {
            tal_token: getSessionStorageTalToken
          }
        }
        privateParams.success ? privateParams.success(res) : function(res) { }
      } else {
        // 如果不存在，则判断Js-Bridge是否存在，如果存在设置Set-Tal-Token字段header头，不存在不设置该字段，且不管存在与否均需要请求校验登录态接口
        if (!window.SET_APP_TAL_TOKEN) {
          // 向app发送获取token的请求
          try {
            window.SET_APP_TAL_TOKEN =   window.talAccSDKJSBridge.getTalToken()
          } catch(err) {
            try {
              window.SET_APP_TAL_TOKEN = window.talAccSdk.TALAccSDKGetTalTokenJSMsgHandler('GET_APP_TAL_TOKEN')
            } catch(err) {
              console.log('web网页')
            }
          }
        }
        var getJsBridgeTalToken = (window.SET_APP_TAL_TOKEN ? window.SET_APP_TAL_TOKEN : '')
        // 设置header头字段数据
        var setRequestHeaderArr = []
        if (getJsBridgeTalToken) {
          setRequestHeaderArr.push({
            fieldName: 'Tal-Token',
            fieldValue: getJsBridgeTalToken || ''
          })
        }
        var setSpecialParams = {
           addHeaders: setRequestHeaderArr
        }
        // 如果不存在Js-Bridge，是在web网页下，接口会主动去校验cookie中的Tal-Token字段，即响应头不存在Tal-Token，就会主动校验cookie中是否存在Tal-Token字段以便校验是否登录
        // 请求校验登录态接口
        _util.axiosPost(cg_host_v1 + '/web/login/status/check', privateParams, setSpecialParams)
      }
    },

    /*
    * @discribe 校验登录态Promise异步请求二次封装
    * @method asyncCheckLogin
    * @param {params} 登录参数
    * @return {Boolean} 返回一个Promise对象
    * */
    asyncCheckLogin: function() {
      var _t = this
      return new Promise(function(resolve, reject){
        var setParams = {
          success: function(res) {
            // errcode为0代表已登录，否则均为未登录，接口返回什么就是什么
            if (res.errcode == 0) {
              resolve(res)
            } else {
              reject(res)
            }
          },
          fail: function(res) {
            var errInfo  = {
              errdata: res,
              errmsg: res.errmsg ? res.errmsg : '网络异常，请刷新重试！'
            }
            reject(errInfo)
          },
          complete: function(res) {
          }
        }
        _t.checkLogin(setParams)
      })
    },

    /*
    * @discribe 展示滑块验证。
    * @method showSlide
    * @param {params} 登录参数
    * @return {Boolean} 返回一个Promise对象
    * */
    showSlide: function(params) {
        if (!_util.validResHeader()) {
            var callback = params.failCallback ? params.failCallback : function() { };
            return callback(_util.getCode(1000000))
        }
        // 无痕验证失败，触发二次验证
        // 二次验证的appkey，scene，test值及success，fail，error的回调由nvc初始化时决定，请不要在二次验证时传入
        // 设置滑块的配置参数，二次验证码（滑动验证码）配置项设置，详情请见滑动验证集成方式文档
        // 设置渲染滑块id元素
        var _renderToEle = configNVCInitParams.renderToEle ? configNVCInitParams.renderToEle.toString().replace(/#/gi, '') : ''
        var ncoption = {
          // 声明滑动验证需要渲染的目标ID。
          renderTo: _renderToEle,
          language: 'cn',
          width: 300,
          // 二次验证文案配置
          upLang: {
           'cn': {
              //加载状态提示。
              'LOADING': "加载中",
              //等待滑动状态提示。
              'SLIDE': "按住滑块，拖动到最右边",
              //验证通过状态提示。
              'SUCCESS': "验证通过",
              //验证失败触发拦截状态提示。
              'ERROR': "非常抱歉，验证失败了",
              //验证失败触发拦截状态提示。
              'FAIL': "验证失败，点击<a href=\"javascript:window.ALI_AWSC_INIT_NVC.reset()\">刷新</a>重试"
            }
          }
        }
        // 唤醒二次验证（滑动验证码）
        if(window.ALI_AWSC_TRIGGE_NC){
          window.ALI_AWSC_INIT_NVC.reset()
        } else {
          window.ALI_AWSC_TRIGGE_NC = 1
          window.ALI_AWSC_INIT_NVC.getNC(ncoption)
        }
        slideCallback = params.slideCallback;
        slideParams = getParams(params.slideParams);
        slidefailCallback = params.failCallback ? params.failCallback : function() { };
    },
    /*
    * @discribe 获取初始化数据
    * @method getInitData
    * */
    getInitData: function(params) {
        if (!_util.validResHeader()) return params.success(_util.getCode(1000000))
        _util.axiosGet(passport_host_v1 + '/web/config/init', params)
    },
    /*
    * @discribe 退出登录。
    * @method loginOut
    * @param {params} 参数
    * */
    loginOut: function(params) {
      if (!_util.validResHeader()) return params.success(_util.getCode(1000000))
      var setSpecialParams = {
        name: 'loginOut'
      }
      _util.axiosGet(passport_host_v1 + '/web/login/logout', params, setSpecialParams)
    },
    /*
    * @discribe 账号密码登录。
    * @method loginPassword
    * @param {params} 登录参数
    * @return {Boolean} 返回一个Promise对象
    * */
    loginPassword: function(params, captchaData) {
        if (!_util.validResHeader()) return params.success(_util.getCode(1000000))
        var privateParams = getParams(params)
        // 验证登录账号不能为空
        if (!_util.validNotEmpty(privateParams.data.symbol)) {
            params.success(_util.getCode(1010000));
            return
        }
        // 验证密码不能为空
        if (!_util.validNotEmpty(privateParams.data.password)) {
            params.success(_util.getCode(1010002));
            return
        }
        var _t = this
        function loginPasswordInit() {
            privateParams.data.source_type = 2
            privateParams.data.domain = domain
            // 重置请求参数
            var setParams = {
                data: privateParams.data || {},
                success: function(res) {
                    // passport登录成功存在一个开启心跳的标识，存在localStorage本地存储中
                    if (res.errcode == 0) {
                        _util.resetLocalStorage.setItem("tal-passport-open-heartbeat-tag", true);
                    }
                    // 调取传递的回调方法
                    privateParams.success ? privateParams.success(res) : function(res) { }

                },
                fail: function(fail) {
                    privateParams.fail ? privateParams.fail(fail) : function(fail) { }
                },
                complete: function(res) {
                    privateParams.complete ? privateParams.complete(res) : function(res) { }
                }
            }
            _util.axiosPost(passport_host_v1 + '/web/login/pwd', setParams)
        }
        // 判断是否调用了滑块
        if (window.TAL_UC_PASSPORT_CONFIG_NVC_INIT) {
            // 初始化了滑块，然后判断是否加载完成
            window.TAL_UC_PASSPORT_CONFIG_NVC_INIT.then(function(res) {
                if (privateParams.data.is_second_verify != 1 && window.ALI_AWSC_INIT_NVC && typeof window.ALI_AWSC_INIT_NVC.getNVCVal === 'function') {
                  // 非二次滑块验证，拼接无痕验证签名
                  privateParams.data.invisible_sig = window.ALI_AWSC_INIT_NVC.getNVCVal()
                }
                // 判断是否加载成功
                if (!(privateParams.data.invisible_sig)) {
                    captchaData = captchaData || {}
                    _t.captchaSendFn(privateParams, {
                        requestName: 'loginPassword',
                        requestUrl: '/web/login/pwd',
                        sceneType: 3,
                        host: passport_host_v1,
                        checkToken: false,
                        specialParams: {
                          isCheckLogin: false
                        }
                    }, captchaData)
                    return false
                } else {
                    loginPasswordInit()
                }
            })
        } else {
            loginPasswordInit()
        }
    },
    /*
   * @discribe 手机号验证码登录。
   * @method loginSms
   * @param {params} 登录参数
   * @return {Boolean} 返回一个Promise对象
   * */
    loginSms: function(params, captchaData) {
        if (!_util.validResHeader()) return params.success(_util.getCode(1000000))
        var privateParams = getParams(params)
        privateParams.data.phone_code = privateParams.data.phone_code ? privateParams.data.phone_code : '86'
        // 验证手机号为空
        if (!_util.validNotEmpty(privateParams.data.phone)) {
            params.success(_util.getCode(1010006));
            return
        }
        // 验证手机号合法性
        if (!_util.validPhone(privateParams.data.phone, privateParams.data.phone_code)) {
            params.success(_util.getCode(1010007));
            return
        }
        // 验证手机验证码为空
        if (!_util.validNotEmpty(privateParams.data.sms_code)) {
            params.success(_util.getCode(1010008));
            return
        }
        // 验证手机号验证码合法性
        if (!_util.validVCode(privateParams.data.sms_code)) {
            params.success(_util.getCode(1010001));
            return
        }
        var _t = this, _loginRequestUrl = "/web/login/sms";
        var urlParams = _util.getUrlParmas(window.location.href);
        if (urlParams.__udc_ctx) {
            __udc_ctx = urlParams.__udc_ctx;
        }
        if (privateParams.data.bindType == 1) {
            // 区分是微信登录还是普通登录,bindType为1是微信授权登录接口
            privateParams.data['ctx'] = __udc_ctx || ''
            _loginRequestUrl = '/web/wx/login/sms'
        } else if (privateParams.data.bindType == 2) {
            // 区分是微信换绑登录,bindType为2是微信换绑登录接口
            _loginRequestUrl = '/web/wx/switch/sms'
        }
        function loginSmsInit() {
            privateParams.data.source_type = 2
            privateParams.data.domain = domain
            // 重置请求参数
            var setParams = {
                data: privateParams.data || {},
                success: function(res) {
                    // passport登录成功存在一个开启心跳的标识，存在localStorage本地存储中
                    if (res.errcode == 0) {
                        _util.resetLocalStorage.setItem("tal-passport-open-heartbeat-tag", true);
                    }
                    // 调取传递的回调方法
                    privateParams.success ? privateParams.success(res) : function(res) { }

                },
                fail: function(fail) {
                    privateParams.fail ? privateParams.fail(fail) : function(fail) { }
                },
                complete: function(res) {
                    privateParams.complete ? privateParams.complete(res) : function(res) { }
                }
            }
            _util.axiosPost(passport_host_v1 + _loginRequestUrl, setParams)
        }
        // 判断是否调用了滑块
        if (window.TAL_UC_PASSPORT_CONFIG_NVC_INIT) {
            // 初始化了滑块，然后判断是否加载完成
            window.TAL_UC_PASSPORT_CONFIG_NVC_INIT.then(function(res) {
                if (privateParams.data.is_second_verify != 1 && window.ALI_AWSC_INIT_NVC && typeof window.ALI_AWSC_INIT_NVC.getNVCVal === 'function') {
                  // 非二次滑块验证，拼接无痕验证签名
                  privateParams.data.invisible_sig = window.ALI_AWSC_INIT_NVC.getNVCVal()
                }
                // 判断是否加载成功
                if (!(privateParams.data.invisible_sig)) {
                    captchaData = captchaData || {}
                    _t.captchaSendFn(privateParams, {
                        requestName: 'loginSms',
                        requestUrl: _loginRequestUrl,
                        sceneType: 2,
                        host: passport_host_v1,
                        checkToken: false,
                        specialParams: {
                          isCheckLogin: false
                        }
                    }, captchaData)
                    return false
                } else {
                    loginSmsInit()
                }
            })
        } else {
            loginSmsInit()
        }
    },
    /*
    * @discribe 登录获取手机验证码。
    * @method sendSMSCodeLogin
    * @param {Object} params  请求参数 参数 type: 0 登录 1 找回密码 2 设置密码
    * @param {Object} captchaData 图形验证场景的数据传参
    * */
    sendSMSCodeLogin: function(params, captchaData) {
        if (!_util.validResHeader()) return params.success(_util.getCode(1000000))
        var privateParams = getParams(params)
        privateParams.data.phone_code = privateParams.data.phone_code ? privateParams.data.phone_code : '86'
        // 验证手机号为空
        if (!_util.validNotEmpty(privateParams.data.phone)) {
            params.success(_util.getCode(1010006));
            return
        }
        // 验证手机号合法性
        if (!_util.validPhone(privateParams.data.phone, privateParams.data.phone_code)) {
            params.success(_util.getCode(1010007));
            return
        }

        var _t = this,
            _smsRequestUrl = '/web/login/sms/send';
        var urlParams = _util.getUrlParmas(window.location.href);
        if (urlParams.__udc_ctx) {
            __udc_ctx = urlParams.__udc_ctx;
        }
        if (privateParams.data.bindType == 1) {
            // 区分是微信登录还是普通登录获取验证码,bindType为1是微信授权登录获取验证码接口

            privateParams.data['ctx'] = __udc_ctx || ''
            console.log(privateParams.data, 'privateParams0-')
            _smsRequestUrl = '/web/wx/login/sms/send'
        } else if (privateParams.data.bindType == 2) {
            _smsRequestUrl = '/web/wx/switch/sms/send'
            console.log(privateParams, 'privateParams-----')
        }
        // 判断是否调用了滑块
        if (window.TAL_UC_PASSPORT_CONFIG_NVC_INIT) {
            // 初始化了滑块，然后判断是否加载完成
            window.TAL_UC_PASSPORT_CONFIG_NVC_INIT.then(function(res) {
                if (privateParams.data.is_second_verify != 1 && window.ALI_AWSC_INIT_NVC && typeof window.ALI_AWSC_INIT_NVC.getNVCVal === 'function') {
                  // 非二次滑块验证，拼接无痕验证签名
                  privateParams.data.invisible_sig = window.ALI_AWSC_INIT_NVC.getNVCVal()
                }
                // 判断是否加载成功
                if (!(privateParams.data.invisible_sig)) {
                    captchaData = captchaData || {}
                    _t.captchaSendFn(privateParams, {
                        requestName: 'sendSMSCodeLogin',
                        requestUrl: _smsRequestUrl,
                        sceneType: 1,
                        host: passport_host_v1,
                        checkToken: false,
                        specialParams: {
                          isCheckLogin: false
                        }
                    }, captchaData)
                    return false
                } else {
                    _util.axiosPost(passport_host_v1 + _smsRequestUrl, privateParams)
                }
            })
        } else {
            _util.axiosPost(passport_host_v1 + _smsRequestUrl, privateParams)
        }
    },
    /*
   * @discribe 密码、手机号修改获取验证码。
   * @method sendSMSCode
   * @param {params} 参数 type: 0 登录 1 找回密码 2 设置密码
   * @return {Boolean} 返回一个Promise对象
   * */
    sendSMSCode: function(params, captchaData) {
        if (!_util.validResHeader()) return params.success(_util.getCode(1000000))
        var privateParams = getParams(params)
        privateParams.data.phone_code = privateParams.data.phone_code ? privateParams.data.phone_code : '86'
        // 验证手机号为空
        if ((privateParams.data.use == 4 || privateParams.data.use == 7) && !_util.validNotEmpty(privateParams.data.phone)) {
            params.success(_util.getCode(1010012))
            return
        }
        // 验证手机号合法性
        if ((privateParams.data.use == 4 || privateParams.data.use == 7) && !_util.validPhone(privateParams.data.phone, privateParams.data.phone_code)) {
            params.success(_util.getCode(1010011))
            return
        }
        var _t = this;
        var set_host = passport_host_v1
        var is_token = false
        // use 为5、6、7时需要登录态，4找回密码不需要登录态
        if (privateParams.data && (privateParams.data.use == 5 || privateParams.data.use == 6 || privateParams.data.use == 7 )) {
          set_host = cg_host_v1
          is_token = true
        }
        // 设置需要登录态的特殊参数
        var setSpecialParams = {
          isCheckLogin: true,
          name: 'sendSMSCode'
        }
        // 判断是否调用了滑块
        if (window.TAL_UC_PASSPORT_CONFIG_NVC_INIT) {
            // 初始化了滑块，然后判断是否加载完成
            window.TAL_UC_PASSPORT_CONFIG_NVC_INIT.then(function(res) {
                if (privateParams.data.is_second_verify != 1 && window.ALI_AWSC_INIT_NVC && typeof window.ALI_AWSC_INIT_NVC.getNVCVal === 'function') {
                  // 非二次滑块验证，拼接无痕验证签名
                  privateParams.data.invisible_sig = window.ALI_AWSC_INIT_NVC.getNVCVal()
                }
                // 判断是否加载成功
                if (!(privateParams.data.invisible_sig)) {
                    captchaData = captchaData || {}
                    _t.captchaSendFn(privateParams, {
                        requestName: 'sendSMSCode',
                        requestUrl: '/web/security/sms',
                        sceneType: 4,
                        host: set_host,
                        checkToken: is_token,
                        specialParams: setSpecialParams
                    }, captchaData)
                    return false
                } else {
                  if (is_token) {
                    _t.asyncCheckLogin().then(function(res){
                      _util.axiosPost(set_host + '/web/security/sms', privateParams, setSpecialParams)
                    }).catch(function(fail){
                      // 未登录，接口返回什么就是什么，原封不动返回给业务方
                      if (fail.errcode) {
                        params.success ? params.success(fail) : function (fail) {}
                      } else {
                        params.fail ? params.fail(fail) : function (fail) {}
                      }
                      params.complete ? params.complete(fail) : function (fail) {}
                    })
                  } else {
                    _util.axiosPost(set_host + '/web/security/sms', privateParams)
                  }
                }
            })
        } else {
          if (is_token) {
            _t.asyncCheckLogin().then(function(res){
               _util.axiosPost(set_host + '/web/security/sms', privateParams, setSpecialParams)
            }).catch(function(fail){
              // 未登录，接口返回什么就是什么，原封不动返回给业务方
              if (fail.errcode) {
                params.success ? params.success(fail) : function (fail) {}
              } else {
                params.fail ? params.fail(fail) : function (fail) {}
              }
              params.complete ? params.complete(fail) : function (fail) {}
            })
          } else {
            _util.axiosPost(set_host + '/web/security/sms', privateParams)
          }
        }
    },
    /*
   * @discribe 获取手机号地区码、仅支持大陆和香港
   * @method getPhoneCodeList
   * @param {params} 参数
   * @return {Boolean} 返回一个Promise对象
   * */
    getPhoneCodeList: function(params) {
        if (!_util.validResHeader()) return params.success(_util.getCode(1000000))
        var privateParams = getParams(params)
        _util.axiosPost(passport_host_v1 + '/web/phonecode/get', privateParams)
    },

    /*
    * @discribe 获取手机号国家码表（支持海外手机号）
    * @method getAllPhoneCodeList
    * @param {params} 参数
    * */
    getAllPhoneCodeList: function(params) {
        if (!_util.validResHeader()) return params.success(_util.getCode(1000000))
        var privateParams = getParams(params)
        _util.axiosPost(passport_host_v1 + '/web/phonecode/foreign/get', privateParams)
    },

    /*
   * @discribe 获取是否绑定手机号和设置密码。
   * @method getSafeInfo
   * @param {params} 参数
   * @return {Boolean} 返回一个Promise对象
   * */
    getSafeInfo: function(params) {
      var privateParams = getParams(params)
      if (!_util.validResHeader()) return params.success(_util.getCode(1000000))
      this.asyncCheckLogin().then(function(res){
        var setSpecialParams = {
          isCheckLogin: true,
          name: 'getSafeInfo'
        }
        _util.axiosGet(cg_host_v1 + '/web/security/info', privateParams, setSpecialParams)
      }).catch(function(fail){
        // 未登录，接口返回什么就是什么，原封不动返回给业务方
        if (fail.errcode) {
          params.success ? params.success(fail) : function (fail) {}
        } else {
          params.fail ? params.fail(fail) : function (fail) {}
        }
        params.complete ? params.complete(fail) : function (fail) {}
      })

    },
    /*
   * @discribe 获取用户主标识。
   * @method getSafeInfo
   * @param {params} 参数
   * @return {Boolean} 返回一个Promise对象
   * */
    getMainSymbol: function(params) {
        var privateParams = getParams(params)
        if (!_util.validResHeader()) return params.success(_util.getCode(1000000))
        _util.axiosGet(passport_host_v1 + '/web/acct/symbol', privateParams)
    },
    /*
   * @discribe 忘记密码，验证旧手机
   * @method checkPhone
   * @param {params} 参数
   * @return {Boolean} 返回一个Promise对象
   * */
    checkPhone: function(params) {
        if (!_util.validResHeader()) return params.success(_util.getCode(1000000))
        var privateParams = getParams(params)
        // 验证类型不能为空
        if (!privateParams.data.type) {
            return params.success(_util.getCode(1010005))
        }
        if (privateParams.data.type == 4) {
            // 忘记密码
            privateParams.data.phone_code = privateParams.data.phone_code ? privateParams.data.phone_code : '86'
            // 验证手机号为空
            if (!_util.validNotEmpty(privateParams.data.phone)) {
                params.success(_util.getCode(1010012));
                return
            }
            // 验证手机号合法性
            if (!_util.validPhone(privateParams.data.phone, privateParams.data.phone_code)) {
                params.success(_util.getCode(1010011));
                return
            }
        }
        // 验证验证码为空
        if (!_util.validNotEmpty(privateParams.data.vcode)) {
            params.success(_util.getCode(1010009));
            return
        }
        // 验证合法性
        if (!_util.validVCode(privateParams.data.vcode)) {
            params.success(_util.getCode(1010013));
            return
        }
        if (privateParams.data.is_second_verify != 1 && window.ALI_AWSC_INIT_NVC && typeof window.ALI_AWSC_INIT_NVC.getNVCVal === 'function') {
          // 非二次滑块验证，拼接无痕验证签名
          privateParams.data.invisible_sig = window.ALI_AWSC_INIT_NVC.getNVCVal()
        }
        // 判断是否需要登录态
        if (privateParams.data.type == 5 || privateParams.data.type == 6) {
          // 换绑手机号和登录态下修改密码，需要登录态
          var setSpecialParams = {
            isCheckLogin: true,
            name: 'checkPhone'
          }
          this.asyncCheckLogin().then(function(res){
            _util.axiosPost(cg_host_v1 + '/web/security/cellphone/check', privateParams, setSpecialParams)
          }).catch(function(fail){
            // 未登录，接口返回什么就是什么，原封不动返回给业务方
            if (fail.errcode) {
              params.success ? params.success(fail) : function (fail) {}
            } else {
              params.fail ? params.fail(fail) : function (fail) {}
            }
            params.complete ? params.complete(fail) : function (fail) {}
          })
        } else {
          // 忘记密码，不需要登录态
          _util.axiosPost(passport_host_v1 + '/web/security/cellphone/check', privateParams)
        }
    },
    /*
    * @discribe 设置密码
    * @method setPassword
    * @param {params} 参数
    * @return {Boolean} 返回一个Promise对象
    * @TODO
    * */
    setPassword: function(params) {
        if (!_util.validResHeader()) return params.success(_util.getCode(1000000))
        var privateParams = getParams(params)
        privateParams.data.phone_code = privateParams.data.phone_code ? privateParams.data.phone_code : '86'
        // 验证密码为空
        if (!_util.validNotEmpty(privateParams.data.password)) {
            params.success(_util.getCode(1010014));
            return
        }
        // 验证密码合法性
        if (!_util.validPwd(privateParams.data.password)) {
            params.success(_util.getCode(1010015));
            return
        }
        // 验证手机号为空
        if (privateParams.data.type == 1 && !_util.validNotEmpty(privateParams.data.phone)) {
            params.success(_util.getCode(1010012));
            return
        }
        // 验证手机号合法性
        if (privateParams.data.type == 1 && !_util.validPhone(privateParams.data.phone)) {
            params.success(_util.getCode(1010011));
            return
        }
        // 判断是否需要登录态
        if (privateParams.data.type == 2) {
          // 修改密码，需要登录态
          this.asyncCheckLogin().then(function(res){
            var setSpecialParams = {
              isCheckLogin: true,
              name: 'setPassword'
            }
            _util.axiosPost(cg_host_v1 + '/web/security/password/set', privateParams, setSpecialParams)
          }).catch(function(fail){
            // 未登录，接口返回什么就是什么，原封不动返回给业务方
            if (fail.errcode) {
              params.success ? params.success(fail) : function (fail) {}
            } else {
              params.fail ? params.fail(fail) : function (fail) {}
            }
            params.complete ? params.complete(fail) : function (fail) {}
          })
        } else {
          // 忘记密码，不需要登录态
          _util.axiosPost(passport_host_v1 + '/web/security/password/set', privateParams)
        }
    },
    /*
    * @discribe 新绑手机号
    * @method setPhone
    * @param {params} 参数
    * @return {Boolean} 返回一个Promise对象
    * @TODO
    * */
    setPhone: function(params, captchaData) {
        if (!_util.validResHeader()) return params.success(_util.getCode(1000000))
        var privateParams = getParams(params);
        privateParams.data.phone_code = privateParams.data.phone_code ? privateParams.data.phone_code : '86'
        // 验证手机号为空
        if (!_util.validNotEmpty(privateParams.data.phone)) {
            params.success(_util.getCode(1010012));
            return
        }
        // 验证手机号合法性
        if (!_util.validPhone(privateParams.data.phone, privateParams.data.phone_code)) {
            params.success(_util.getCode(1010011));
            return
        }
        // 验证验证码为空
        if (!_util.validNotEmpty(privateParams.data.vcode)) {
            params.success(_util.getCode(1010009));
            return
        }
        // 验证验证码合法性
        if (!_util.validVCode(privateParams.data.vcode)) {
            params.success(_util.getCode(1010013));
            return
        }
        var _t = this
        // 设置需要登录态的特殊参数
        var setSpecialParams = {
          isCheckLogin: true,
          name: 'setPhone'
        }
        // 判断是否调用了滑块
        if (window.TAL_UC_PASSPORT_CONFIG_NVC_INIT) {
            // 初始化了滑块，然后判断是否加载完成
            window.TAL_UC_PASSPORT_CONFIG_NVC_INIT.then(function(res) {
                if (privateParams.data.is_second_verify != 1 && window.ALI_AWSC_INIT_NVC && typeof window.ALI_AWSC_INIT_NVC.getNVCVal === 'function') {
                  // 非二次滑块验证，拼接无痕验证签名
                  privateParams.data.invisible_sig = window.ALI_AWSC_INIT_NVC.getNVCVal()
                }
                // 判断是否加载成功
                if (!(privateParams.data.invisible_sig)) {
                    captchaData = captchaData || {}
                    _t.captchaSendFn(privateParams, {
                        requestName: 'setPhone',
                        requestUrl: '/web/security/cellphone/set',
                        sceneType: 5,
                        host: cg_host_v1,
                        checkToken: true,
                        specialParams: setSpecialParams
                    }, captchaData)
                    return false
                } else {
                  _t.asyncCheckLogin().then(function(res){
                    _util.axiosPost(cg_host_v1 + '/web/security/cellphone/set', privateParams, setSpecialParams)
                  }).catch(function(fail){
                    // 未登录，接口返回什么就是什么，原封不动返回给业务方
                    if (fail.errcode) {
                      params.success ? params.success(fail) : function (fail) {}
                    } else {
                      params.fail ? params.fail(fail) : function (fail) {}
                    }
                    params.complete ? params.complete(fail) : function (fail) {}
                  })
                }
            })
        } else {
            _t.asyncCheckLogin().then(function(res){
              _util.axiosPost(cg_host_v1 + '/web/security/cellphone/set', privateParams, setSpecialParams)
            }).catch(function(fail){
              // 未登录，接口返回什么就是什么，原封不动返回给业务方
              if (fail.errcode) {
                params.success ? params.success(fail) : function (fail) {}
              } else {
                params.fail ? params.fail(fail) : function (fail) {}
              }
              params.complete ? params.complete(fail) : function (fail) {}
            })
        }
    },
    /*
    * @discribe 换绑手机号
    * @method changePhone
    * @param {params} 参数
    * @return {Boolean} 返回一个Promise对象
    * @TODO
    * */
    changePhone: function(params, captchaData) {
        if (!_util.validResHeader()) return params.success(_util.getCode(1000000))
        var privateParams = getParams(params);
        privateParams.data.phone_code = privateParams.data.phone_code ? privateParams.data.phone_code : '86'
        // 验证手机号为空
        if (!_util.validNotEmpty(privateParams.data.phone)) {
            params.success(_util.getCode(1010012));
            return
        }
        // 验证手机号合法性
        if (!_util.validPhone(privateParams.data.phone, privateParams.data.phone_code)) {
            params.success(_util.getCode(1010011));
            return
        }
        // 验证验证码为空
        if (!_util.validNotEmpty(privateParams.data.vcode)) {
            params.success(_util.getCode(1010009));
            return
        }
        // 验证验证码合法性
        if (!_util.validVCode(privateParams.data.vcode)) {
            params.success(_util.getCode(1010016));
            return
        }
        // 验证TAG不能为空
        if (!_util.validNotEmpty(privateParams.data.tag)) {
            params.success(_util.getCode(1010003));
            return
        }
        var _t = this
        // 设置需要登录态的特殊参数
        var setSpecialParams = {
          isCheckLogin: true,
          name: 'changePhone'
        }
        // 判断是否调用了滑块
        if (window.TAL_UC_PASSPORT_CONFIG_NVC_INIT) {
            // 初始化了滑块，然后判断是否加载完成
            window.TAL_UC_PASSPORT_CONFIG_NVC_INIT.then(function(res) {
                if (privateParams.data.is_second_verify != 1 && window.ALI_AWSC_INIT_NVC && typeof window.ALI_AWSC_INIT_NVC.getNVCVal === 'function') {
                  // 非二次滑块验证，拼接无痕验证签名
                  privateParams.data.invisible_sig = window.ALI_AWSC_INIT_NVC.getNVCVal()
                }
                // 判断是否加载成功
                if (!(privateParams.data.invisible_sig)) {
                    captchaData = captchaData || {}
                    _t.captchaSendFn(privateParams, {
                        requestName: 'changePhone',
                        requestUrl: '/web/security/cellphone/update',
                        sceneType: 6,
                        host: cg_host_v1,
                        checkToken: true,
                        specialParams: setSpecialParams
                    }, captchaData)
                    return false
                } else {
                  _t.asyncCheckLogin().then(function(res){
                    _util.axiosPost(cg_host_v1 + '/web/security/cellphone/update', privateParams, setSpecialParams)
                  }).catch(function(fail){
                    // 未登录，接口返回什么就是什么，原封不动返回给业务方
                    if (fail.errcode) {
                      params.success ? params.success(fail) : function (fail) {}
                    } else {
                      params.fail ? params.fail(fail) : function (fail) {}
                    }
                    params.complete ? params.complete(fail) : function (fail) {}
                  })
                }
            })
        } else {
            _t.asyncCheckLogin().then(function(res){
              _util.axiosPost(cg_host_v1 + '/web/security/cellphone/update', privateParams, setSpecialParams)
            }).catch(function(fail){
              // 未登录，接口返回什么就是什么，原封不动返回给业务方
              if (fail.errcode) {
                params.success ? params.success(fail) : function (fail) {}
              } else {
                params.fail ? params.fail(fail) : function (fail) {}
              }
              params.complete ? params.complete(fail) : function (fail) {}
            })
        }
    },
    /********* 用户信息相关 ********/
    /*
    * @discribe 获取用户信息
    * @method detailUser
    * @param {params} 参数
    * @return {Boolean} 返回一个Promise对象
    * */
    detailUser: function(params) {
      if (!_util.validResHeader()) return params.success(_util.getCode(1000000))
        this.asyncCheckLogin().then(function(res){
          var setSpecialParams = {
            isCheckLogin: true,
            name: 'detailUser'
          }
          _util.axiosGet(cg_host_v1 + '/web/user/info', getParams(params), setSpecialParams)
        }).catch(function(fail){
          // 未登录，接口返回什么就是什么，原封不动返回给业务方
          if (fail.errcode) {
            params.success ? params.success(fail) : function (fail) {}
          } else {
            params.fail ? params.fail(fail) : function (fail) {}
          }
          params.complete ? params.complete(fail) : function (fail) {}
        })
    },
    /*
    * @discribe 修改用户信息
    * @method modifyUserInfo
    * @param {params} 参数
    * @return {Boolean} 返回一个Promise对象
    * */
    modifyUserInfo: function(params) {
        if (!_util.validResHeader()) return params.success(_util.getCode(1000000))
        // 判断是v1还是v2
        var new_host = cg_host_v1
        if (params.data.version) {
            new_host = cg_host_v2 + '/' + params.data.version
            delete params.data.version
        }
        var privateParams = getParams(params);
        var pattern = new RegExp("[`~!@#$%^&*()_\\-+=<>?:\"{}|,.\\/;'\\\\[\\]·~！@#￥%……&*（）——\\-+={}|《》？：“” 【】、；‘’，。、]", 'g');
        // 通行证验证
        if (privateParams.data.tal_name !== undefined) {
            if (pattern.test(privateParams.data.tal_name)) {
                return params.success(_util.getCode(1020000))
            }
            if (!/^[0-9a-zA-Z]{8,16}$/.test(privateParams.data.tal_name)) {
                return params.success(_util.getCode(1020000))
            }
            if (/^\d+$/.test(privateParams.data.tal_name)) {
                return params.success(_util.getCode(1020000))
            }
        }
        // 昵称验证
        if (privateParams.data.nickname !== undefined) {
            if (pattern.test(privateParams.data.nickname)) {
                return params.success(_util.getCode(1020001))
            }
            if (privateParams.data.nickname.length > 32) {
                return params.success(_util.getCode(1020001))
            }
            if (_util.validEmpty(privateParams.data.nickname)) {
                return params.success(_util.getCode(1020001))
            }
        }
        // 真实姓名验证
        if (privateParams.realname !== undefined) {
            var regName = /^[a-z0-9A-Z&\-,（）(). \u4e00-\u9fa5]+$/;
            if (!regName.test(privateParams.data.realname)) {
                return params.success(_util.getCode(1020002))
            }
            /*验证32位*/
            if (privateParams.data.realname.length > 32) {
                return params.success(_util.getCode(1020002))
            }
            if (_util.validEmpty(privateParams.data.realname)) {
                return params.success(_util.getCode(1020002))
            }
        }
        // 英文名验证
        /*k可以多位空格*/
        if (privateParams.data.en_name !== undefined) {
            var enreg = /^[a-zA-Z ]+$/;
            if (!enreg.test(privateParams.data.en_name)) {
                return params.success(_util.getCode(1020003))
            }
            if (privateParams.data.en_name.length > 32) {
                return params.success(_util.getCode(1020003))
            }
            if (_util.validEmpty(privateParams.data.en_name)) {
                return params.success(_util.getCode(1020003))
            }
        }
        // 生日验证
        if (privateParams.data.birthday !== undefined) {
            // var regBir = /^\d{4}-\d{2}-\d{2}$/;
            // var regBir = /^\d{4}-([0][123456789]|[1][012])-([012][123456789]|[3][01])$/;
            var regBir = /^(19|20)\d{2}\-((0?[1-9])|(1[0-2]))\-((0?[1-9])|([1-2]\d)|3[01])$/
            if (!regBir.test(privateParams.data.birthday)) {
                return params.success(_util.getCode(1020004))
            }
        }
        // 入学年级验证
        if (privateParams.data.school_year !== undefined) {
            var regBir = /^\d{4}$/;
            if (!regBir.test(privateParams.data.school_year)) {
                return params.success(_util.getCode(1020005))
            }
        }
        // 地区校验
        if (privateParams.data.province > 0) {
            if (privateParams.data.city <= 0) {
                return params.success(_util.getCode(1040001))
            }
        }
        this.asyncCheckLogin().then(function(res){
          var setSpecialParams = {
            isCheckLogin: true,
            name: 'modifyUserInfo'
          }
          _util.axiosPost(new_host + '/web/user/modify', privateParams, setSpecialParams)
        }).catch(function(fail){
          // 未登录，接口返回什么就是什么，原封不动返回给业务方
          if (fail.errcode) {
            params.success ? params.success(fail) : function (fail) {}
          } else {
            params.fail ? params.fail(fail) : function (fail) {}
          }
          params.complete ? params.complete(fail) : function (fail) {}
        })
    },
    /*
    * @discribe 上传用户头像
    * @method uploadPhoto
    * @param {params} 参数
    * @return {Boolean} 返回一个Promise对象
    * */
    uploadPhoto: function(params) {
        if (!_util.validResHeader()) return params.success(_util.getCode(1000000))
        // 判断是v1还是v2
        var new_host = cg_host_v1,
            _t = this
        // 已登录
        if (params.data.version) {
            new_host = cg_host_v2 + '/' + params.data.version
            delete params.data.version
        }
        // tal_id为空
        if (!_util.validNotEmpty(params.data.tal_id)) {
            params.success(_util.getCode(1040006));
            return
        }
        var allowArr = ['png', 'jpg', 'jpeg', 'gif'];
        var type = params.data.avatar.type
        var imgType = type.split('/')[1]
        if (allowArr.indexOf(imgType.toLocaleLowerCase()) == -1) {
            return params.success(_util.getCode(1020006))
        }
        var formData = new FormData();
        for (var i in params.data) {
            formData.append(i, params.data[i])
        }
        params.data = formData
        _t.asyncCheckLogin().then(function(res){
          var setSpecialParams = {
            isCheckLogin: true,
            type: 'formdata',
            headersType: reqMultipart,
            name: 'uploadPhoto'
          }
          _util.axiosPost(new_host + '/web/user/avatar', params, setSpecialParams)
        }).catch(function(fail){
          // 未登录，接口返回什么就是什么，原封不动返回给业务方
          if (fail.errcode) {
            params.success ? params.success(fail) : function (fail) {}
          } else {
            params.fail ? params.fail(fail) : function (fail) {}
          }
          params.complete ? params.complete(fail) : function (fail) {}
        })
    },
    /*
    * @discribe 新增收货地址
    * @method createAddress
    * @param {params} 参数
    * @return {Boolean} 返回一个Promise对象
    * */
    createAddress: function(params) {
        if (!_util.validResHeader()) return params.success(_util.getCode(1000000))
        var privateParams = getParams(params);
        privateParams.data.phone_code = privateParams.data.phone_code ? privateParams.data.phone_code : '86'
        var nameLen = privateParams.data.name ? privateParams.data.name.length : 0;
        // 验证收货人姓名为空
        if (_util.validEmpty(privateParams.data.name)) {
            return params.success(_util.getCode(1030005))
        }
        // 验证收货人姓名合法性
        if (nameLen < 1 || nameLen > 32 || (!/^[a-z0-9A-Z&\-,（）(). \u4e00-\u9fa5]+$/.test(privateParams.data.name))) {
            return params.success(_util.getCode(1030001))
        }
        /*不支持香港只验证大陆*/
        // 验证手机号为空
        if (_util.validEmpty(privateParams.data.phone)) {
            return params.success(_util.getCode(1030006))
        }
        // 验证手机号的合法性
        if (!_util.validPhone(privateParams.data.phone, '86')) {
            return params.success(_util.getCode(1030007))
        }
        // 验证省份信息为空
        if (!privateParams.data.province) {
            return params.success(_util.getCode(1040003))
        }
        // 验证省份信息合法性
        if (privateParams.data.province <= 0) {
            return params.success(_util.getCode(1040000))
        }
        // 验证城市信息为空
        if (!privateParams.data.city) {
            return params.success(_util.getCode(1040004))
        }
        // 验证城市信息合法性
        if (privateParams.data.city <= 0) {
            return params.success(_util.getCode(1040001))
        }
        // 验证区县信息为空
        if (!privateParams.data.county) {
            return params.success(_util.getCode(1040005))
        }
        // 验证区县信息合法性
        if (privateParams.data.county <= 0) {
            return params.success(_util.getCode(1040002))
        }
        // 验证收货地址详细信息为空
        if (_util.validEmpty(privateParams.data.detail)) {
            return params.success(_util.getCode(1030008))
        }
        // 验证收货地址详细信息合法性
        if (privateParams.data.detail.length > 100) {
            return params.success(_util.getCode(1030003))
        }
        // 验证备注信息长度合法性
        if (privateParams.data.remark) {
            if (_util.trim(privateParams.data.remark).length > 100) {
                return params.success(_util.getCode(1030004))
            }
        }
        this.asyncCheckLogin().then(function(res){
          var setSpecialParams = {
            isCheckLogin: true,
            name: 'createAddress'
          }
          _util.axiosPost(cg_host_v1 + '/web/address/create', privateParams, setSpecialParams)
        }).catch(function(fail){
          // 未登录，接口返回什么就是什么，原封不动返回给业务方
          if (fail.errcode) {
            params.success ? params.success(fail) : function (fail) {}
          } else {
            params.fail ? params.fail(fail) : function (fail) {}
          }
          params.complete ? params.complete(fail) : function (fail) {}
        })
    },
    /*
    * @discribe 获取地址列表
    * @method listAddress
    * @param {params} 参数
    * @return {Boolean} 返回一个Promise对象
    * */
    listAddress: function(params) {
      if (!_util.validResHeader()) return params.success(_util.getCode(1000000))
      var privateParams = getParams(params);
      this.asyncCheckLogin().then(function(res){
        var setSpecialParams = {
          isCheckLogin: true,
          name: 'listAddress'
        }
        _util.axiosGet(cg_host_v1 + '/web/address/list', privateParams, setSpecialParams)
      }).catch(function(fail){
        // 未登录，接口返回什么就是什么，原封不动返回给业务方
        if (fail.errcode) {
          params.success ? params.success(fail) : function (fail) {}
        } else {
          params.fail ? params.fail(fail) : function (fail) {}
        }
        params.complete ? params.complete(fail) : function (fail) {}
      })
    },
    /*
    * @discribe 获取地址信息
    * @method listAddress
    * @param {params} 参数
    * @return {Boolean} 返回一个Promise对象
    * */
    infoAddress: function(params) {
        if (!_util.validResHeader()) return params.success(_util.getCode(1000000))
        var privateParams = getParams(params);
        // 地址id非空校验
        if (!privateParams.data.addr_id) {
            return params.success(_util.getCode(1030000))
        }
        this.asyncCheckLogin().then(function(res){
          var setSpecialParams = {
            isCheckLogin: true,
            name: 'infoAddress'
          }
          _util.axiosPost(cg_host_v1 + '/web/address/info', privateParams, setSpecialParams)
        }).catch(function(fail){
          // 未登录，接口返回什么就是什么，原封不动返回给业务方
          if (fail.errcode) {
            params.success ? params.success(fail) : function (fail) {}
          } else {
            params.fail ? params.fail(fail) : function (fail) {}
          }
          params.complete ? params.complete(fail) : function (fail) {}
        })
    },
    /*
    * @discribe 修改地址
    * @method modifyAddress
    * @param {params} 参数
    * @return {Boolean} 返回一个Promise对象
    * */
    modifyAddress: function(params) {
        if (!_util.validResHeader()) return params.success(_util.getCode(1000000))
        var privateParams = getParams(params);
        privateParams.data.phone_code = privateParams.data.phone_code ? privateParams.data.phone_code : '86'
        var nameLen = privateParams.data.name ? privateParams.data.name.length : 0;
        // 验证收货人姓名为空
        if (_util.validEmpty(privateParams.data.name)) {
            return params.success(_util.getCode(1030005))
        }
        // 验证收货人姓名合法性
        if (nameLen < 1 || nameLen > 32 || (!/^[a-z0-9A-Z&\-,（）(). \u4e00-\u9fa5]+$/.test(privateParams.data.name))) {
            return params.success(_util.getCode(1030001))
        }
        /*不支持香港只验证大陆*/
        // 验证手机号为空
        if (_util.validEmpty(privateParams.data.phone)) {
            return params.success(_util.getCode(1030006))
        }
        // 验证手机号的合法性
        if (!_util.validPhone(privateParams.data.phone, '86')) {
            return params.success(_util.getCode(1030007))
        }
        // 验证省份信息为空
        if (!privateParams.data.province) {
            return params.success(_util.getCode(1040003))
        }
        // 验证省份信息合法性
        if (privateParams.data.province <= 0) {
            return params.success(_util.getCode(1040000))
        }
        // 验证城市信息为空
        if (!privateParams.data.city) {
            return params.success(_util.getCode(1040004))
        }
        // 验证城市信息合法性
        if (privateParams.data.city <= 0) {
            return params.success(_util.getCode(1040001))
        }
        // 验证区县信息为空
        if (!privateParams.data.county) {
            return params.success(_util.getCode(1040005))
        }
        // 验证区县信息合法性
        if (privateParams.data.county <= 0) {
            return params.success(_util.getCode(1040002))
        }
        // 验证收货地址详细信息为空
        if (_util.validEmpty(privateParams.data.detail)) {
            return params.success(_util.getCode(1030008))
        }
        // 验证收货地址详细信息合法性
        if (privateParams.data.detail.length > 100) {
            return params.success(_util.getCode(1030003))
        }
        // 验证备注信息长度合法性
        if (privateParams.data.remark) {
            if (_util.trim(privateParams.data.remark).length > 100) {
                return params.success(_util.getCode(1030004))
            }
        }
        this.asyncCheckLogin().then(function(res){
          var setSpecialParams = {
            isCheckLogin: true,
            name: 'modifyAddress'
          }
          _util.axiosPost(cg_host_v1 + '/web/address/modify', privateParams, setSpecialParams)
        }).catch(function(fail){
          // 未登录，接口返回什么就是什么，原封不动返回给业务方
          if (fail.errcode) {
            params.success ? params.success(fail) : function (fail) {}
          } else {
            params.fail ? params.fail(fail) : function (fail) {}
          }
          params.complete ? params.complete(fail) : function (fail) {}
        })
    },
    /*
    * @discribe 设置默认地址
    * @method defaultAddress
    * @param {params} 参数
    * @return {Boolean} 返回一个Promise对象
    * */
    defaultAddress: function(params) {
        if (!_util.validResHeader()) return params.success(_util.getCode(1000000))
        params.data.is_default = '1'
        var privateParams = getParams(params);
        // 地址id非空校验
        if (!privateParams.data.addr_id) {
            return params.success(_util.getCode(1030000))
        }
        this.asyncCheckLogin().then(function(res){
          var setSpecialParams = {
            isCheckLogin: true,
            name: 'defaultAddress'
          }
          _util.axiosPost(cg_host_v1 + '/web/address/modify', privateParams, setSpecialParams)
        }).catch(function(fail){
          // 未登录，接口返回什么就是什么，原封不动返回给业务方
          if (fail.errcode) {
            params.success ? params.success(fail) : function (fail) {}
          } else {
            params.fail ? params.fail(fail) : function (fail) {}
          }
          params.complete ? params.complete(fail) : function (fail) {}
        })
    },
    /*
    * @discribe 取消默认地址
    * @method defaultAddress
    * @param {params} 参数
    * @return {Boolean} 返回一个Promise对象
    * */
    cancelAddress: function(params) {
        if (!_util.validResHeader()) return params.success(_util.getCode(1000000))
        params.data.is_default = '2'
        var privateParams = getParams(params);
        // 地址id非空校验
        if (!privateParams.data.addr_id) {
            return params.success(_util.getCode(1030000))
        }
        this.asyncCheckLogin().then(function(res){
          var setSpecialParams = {
            isCheckLogin: true,
            name: 'cancelAddress'
          }
          _util.axiosPost(cg_host_v1 + '/web/address/modify', privateParams, setSpecialParams)
        }).catch(function(fail){
          // 未登录，接口返回什么就是什么，原封不动返回给业务方
          if (fail.errcode) {
            params.success ? params.success(fail) : function (fail) {}
          } else {
            params.fail ? params.fail(fail) : function (fail) {}
          }
          params.complete ? params.complete(fail) : function (fail) {}
        })
    },
    /*
    * @discribe 删除地址
    * @method delAddress
    * @param {params} 参数
    * @return {Boolean} 返回一个Promise对象
    * */
    delAddress: function(params) {
        if (!_util.validResHeader()) return params.success(_util.getCode(1000000))
        var privateParams = getParams(params);
        // 地址id非空校验
        if (!privateParams.data.addr_id) {
            return params.success(_util.getCode(1030000))
        }
        this.asyncCheckLogin().then(function(res){
          var setSpecialParams = {
            isCheckLogin: true,
            name: 'delAddress'
          }
          _util.axiosPost(cg_host_v1 + '/web/address/del', privateParams, setSpecialParams)
        }).catch(function(fail){
          // 未登录，接口返回什么就是什么，原封不动返回给业务方
          if (fail.errcode) {
            params.success ? params.success(fail) : function (fail) {}
          } else {
            params.fail ? params.fail(fail) : function (fail) {}
          }
          params.complete ? params.complete(fail) : function (fail) {}
        })
    },
    /********* 地区信息省市区相关 ********/
    /*
    * @discribe 获取省信息
    * @method getProvinces
    * @param {params} 参数
    * @return {Promise} 返回一个Promise对象
    * */
    getProvinces: function(params) {
        if (!_util.validResHeader()) return params.success(_util.getCode(1000000))
        var privateParams = getParams(params)
        _util.axiosGet(passport_host_v1 + '/web/area/province/list', privateParams)
    },
    /*
    * @discribe 根据省id获取市信息
    * @method getCity
    * @param {params} 参数
    * @return {Promise} 返回一个Promise对象
    * */
    getCitys: function(params) {
        if (!_util.validResHeader()) return params.success(_util.getCode(1000000))
        var privateParams = getParams(params)
        if (!_util.validNotEmpty(privateParams.data.province_id)) {
            return params.success(_util.getCode(1040003))
        }
        _util.axiosGet(passport_host_v1 + '/web/area/city/list', privateParams)
    },
    /*
    * @discribe 根据市id获取区县信息
    * @method getCounty
    * @param {params} 参数
    * @return {Promise} 返回一个Promise对象
    * */
    getCounty: function(params) {
        if (!_util.validResHeader()) return params.success(_util.getCode(1000000))
        var privateParams = getParams(params)
        if (!_util.validNotEmpty(privateParams.data.citie_id)) {
            return params.success(_util.getCode(1040004))
        }
        _util.axiosGet(passport_host_v1 + '/web/area/county/list', privateParams)
    },
    /*
    * @discribe 心跳接口
    * @param {params} 参数
    * */
    checkHeartbeat: function(params) {
        if (!_util.validResHeader()) return (params.success ? params.success(_util.getCode(1000000)) : '')
        var privateParams = getParams(params)
        // resetSessionStorage
        // 判断本地缓存sessionStorage是否存在tal-passport-jssdk-tal-token字段，存在该接口设置Tal-Token字段header头，否则不设置该字段
        var getSessionStorageTalToken = _util.resetSessionStorage.getItem('tal-passport-jssdk-tal-token') || ''
        // 设置header头字段数据
        var setRequestHeaderArr = []
        if (getSessionStorageTalToken) {
          setRequestHeaderArr.push({
            fieldName: 'Tal-Token',
            fieldValue: getSessionStorageTalToken || ''
          })
        }
        var setSpecialParams = {
           addHeaders: setRequestHeaderArr,
           name: 'checkHeartbeat'
        }
        _util.axiosPost(passport_host_v1 + '/web/login/status/check', privateParams, setSpecialParams)
    },

    /**
     * @name: startPollingQRCodeStatus 
     * @description: 轮询二维码的状态
     * @param {qrcodeId} 二维码code_id
     * @param {interval} 轮询间隔时间
     * @param {onResult} 每次轮询成功获取到二维码状态数据的回调
     * @param {onScanned} 用户扫码时回调
     * @param {onExpired} 二维码失效，过期回调
     * @param {successCallback} 用户同意授权时回调
     * @param {onCancel} 用户取消授权时回调
     * @param {onError} 获取二维码状态接口失败（errcode !== 0）时回调
     * @return: 
     */
    qrCodeStartPollingStatus(options = {}) {
        let { qrcodeId,
            onResult,
            onScanned,
            onExpired,
            successCallback,
            onCancel,
            onError,
            setQrcodeStatus } = options;
        let calledOnScanned = false,
            interval = 1000,
            _t = this;
        function setTimeouthandler() {
            intervalNum = setTimeout(() => {
                _util.axiosGet(passport_host_v1 + '/web/login/qrcode/check', {
                    data: {
                        code_id: qrcodeId || ''
                    },
                    success: function(res) {
                        if (res.errcode === 0) {
                            const { data } = res;
                            //每次轮询成功获取查询二维码状态接口的数据
                            if (onResult) {
                                onResult(res)
                            }
                            //用户扫码成功---同意授权-成功登陆
                            if (data.code_status === 3 && setQrcodeStatus != data.code_status) {
                                // 扫码成功之后不再执行定时器
                                clearTimeout(intervalNum);
                                const successDataCode = {
                                    "data": {
                                        "code": data.code
                                    }
                                };
                                const successData = Object.assign(res, successDataCode);
                                if (successCallback && typeof successCallback === 'function') {
                                    successCallback(successData)
                                }
                            }
                            //用户已扫码---暂时没有任何操作（同意与否）
                            if (data.code_status === 2 && setQrcodeStatus != data.code_status) {
                                if (onScanned) {
                                    onScanned()
                                }
                            }
                            //二维码已失效或者已过期
                            if (data.code_status === 4 && setQrcodeStatus != data.code_status) {
                                // 二维码已失效或者已过期之后不再执行定时器
                                clearTimeout(intervalNum)
                                //提示用户重新生成二维码
                                if (onExpired) {
                                    onExpired()
                                }
                            }
                            //用户扫码成功---但取消授权登陆
                            if (data.code_status === 5 && setQrcodeStatus != data.code_status) {
                                // 用户扫码成功---但取消授权登陆之后不再执行定时器
                                clearTimeout(intervalNum)
                                //提示用户重新生成二维码
                                if (onCancel) {
                                    onCancel()
                                }
                            }

                            // data.code_status!=3、4、5时 重启下一个请求轮询
                            if (data.code_status != 3 && data.code_status != 4 && data.code_status != 5) {
                                setTimeouthandler()
                            }
                            // 设置二维码状态setQrcodeStatus
                            setQrcodeStatus = data.code_status || ''
                        } else {
                            // 重启下一个请求轮询
                            // setTimeouthandler()
                            //获取二维码状态查询失败回调 (errcode !== 0) --- 登陆失败UI页面
                            if (onError) {
                                onError(res)
                            }
                        }
                    },
                    fail: function(res) {
                        // 请求失败，重启下一个请求轮询
                        setTimeouthandler()
                    }
                })
            }, interval)
        }
        setTimeouthandler()
        // return intervalNum
    },

    /**
     * @name: cancelQrcode
     * @description: 切换到非二维码登录方式的特殊处理
     * @param {type} null
     * @return: null
     */
    cancelQrcode() {
        // 清除dom轮询定时器
        if (intervalRenderDomNum) {
            clearInterval(intervalRenderDomNum)
        }
        // 清除检测二维码状态定时器
        if (intervalNum) {
            clearTimeout(intervalNum);
        }
        const createScanExpired = (onClickTh) => {
            //创建蒙版
            let shadowId = 'tal_retry';
            if (document.getElementById(shadowId)) {
                _util.removeElement(document.getElementById(shadowId));
            }
            const shadow_box = document.createElement('div');
            shadow_box.id = shadowId;
            //状态语
            const tip_s = document.createElement('p');
            tip_s.id = 'tal_heading-subtitle';
            tip_s.innerHTML = "二维码已失效";
            //提示警告语
            const tip_w = document.createElement('a');
            tip_w.id = 'tal_heading-subtitle-expired';
            tip_w.onclick = onClickTh;
            tip_w.innerHTML = '点击刷新';

            const tip_box = document.createElement('div');
            tip_box.id = 'tal_tip-inner'

            tip_box.appendChild(tip_s);
            tip_box.appendChild(tip_w);
            shadow_box.appendChild(tip_box);

            return shadow_box;
        }

        if (qrCodeBoxNode) {
            // 如果采取v-if显示隐藏二维码渲染dom，此时已经不存在渲染dom中的任何结构
            setTimeout(function() {
                const wrapper = "tal_qrcode-wrapper"
                const wrapperEle = document.getElementById(wrapper)
                if (wrapperEle) {
                    wrapperEle.appendChild(createScanExpired(() => { startShow(3) }))
                }
            })
        }
    },

    /**
     * @name: loginQrcode
     * @description: 微信扫码登录web端流程
     * @param {renderToEle} 需要渲染的DOM ID
     * @param {onScanned} 用户扫码时回调
     * @param {onExpired} 二维码失效，过期回调
     * @param {successCallback} 用户同意授权时回调
     * @param {onCancel} 用户取消授权时回调
     * @param {onError} 获取二维码状态接口失败（errcode !== 0）时回调
     * @return: 
     */
    loginQrcode(options = {}) {
        let { renderToEle,
            onScanned,
            onExpired,
            successCallback,
            onCancel,
            onError,
            onQRCodeShow,
            onQRCodeLoad,
            onQRCodeLoadFaild,
            netWorkErrTips = "网络出错，请重试"
        } = options;
        var _t = this,
            renderDomNum = 1;
        // 初始化之前如果定时器存在先清除
        if (intervalRenderDomNum) {
            clearInterval(intervalRenderDomNum)
        }
        // 异步，目的为了v-if显示renderToEle时能够获取到dom
        intervalRenderDomNum = setTimeout(function() {
            // 渲染dom最多不超过2s即20次轮询，超过停止轮询，清除定时器
            if (renderDomNum > 20) {
                clearInterval(intervalRenderDomNum)
            }
            renderDomNum += 1
            //挂载渲染的元素id
            const mountNode = renderToEle;
            qrCodeBoxNode = document.querySelector(mountNode);
            let qrcodeNode = document.querySelector(mountNode);
            if (qrcodeNode) {
                // 渲染dom存在之后清除定时器intervalRenderDomNum
                clearInterval(intervalRenderDomNum)
                let qrcodeWrapper;

                //点击刷新的loading元素
                const loading = () => {
                    qrcodeNode.innerHTML = '<div id="tal_qrcode-wrapper"><div id="tal_spinner" class="tal_spinner"><div class="tal_spinner-container"><span class="spinner-snake"></span><span class="spinner-text">加载中</span></div></div></div>'
                };

                const unloading = () => {
                    const child = document.getElementById('tal_qrcode-wrapper');
                    qrcodeNode.removeChild(child);
                };

                //创建扫码成功状态元素
                const createScanSuccess = () => {
                    //创建蒙版
                    let shadowId = 'tal_retry';
                    if (document.getElementById(shadowId)) {
                        _util.removeElement(document.getElementById(shadowId));
                    }
                    const shadow_box = document.createElement('div');
                    shadow_box.id = shadowId;
                    //状态语
                    const tip_s = document.createElement('span');
                    tip_s.id = 'tal_heading-subtitle';
                    tip_s.innerHTML = '扫描成功';
                    //提示警告语
                    const tip_w = document.createElement('p');
                    tip_w.id = 'tal_heading-subtitle-warn';
                    tip_w.innerHTML = '请在手机上根据提示确认登录';
                    //提示icon
                    const warn_icon_inner = document.createElement('div');
                    const warn_icon = document.createElement('div');
                    warn_icon_inner.id = 'tal_heading-icon-fail-inner'
                    warn_icon.id = 'tal_heading-icon-success'
                    warn_icon_inner.appendChild(warn_icon)

                    const tip_box = document.createElement('div');
                    tip_box.id = 'tal_tip-inner'

                    tip_box.appendChild(warn_icon_inner);
                    tip_box.appendChild(tip_s);
                    tip_box.appendChild(tip_w);
                    shadow_box.appendChild(tip_box);

                    return shadow_box;
                }


                //创建扫码登陆失败状态元素
                const createScanFail = (onClickTh) => {
                    //创建蒙版
                    let shadowId = 'tal_retry';
                    if (document.getElementById(shadowId)) {
                        _util.removeElement(document.getElementById(shadowId));
                    }
                    const shadow_box = document.createElement('div');
                    shadow_box.id = shadowId;
                    //状态语
                    const tip_s = document.createElement('span');
                    tip_s.id = 'tal_heading-subtitle';
                    tip_s.innerHTML = "登录失败";
                    //提示警告语
                    const tip_w = document.createElement('p');
                    tip_w.id = 'tal_heading-subtitle-warn';

                    const tip_w_b = document.createElement('span');
                    tip_w_b.innerHTML = '重新扫描二维码，点击'
                    const tip_w_r = document.createElement('a');
                    tip_w_r.id = 'tal_heading-subtitle-refresh';
                    tip_w_r.onclick = onClickTh;
                    tip_w_r.innerHTML = '刷新';
                    tip_w.appendChild(tip_w_b)
                    tip_w.appendChild(tip_w_r)
                    //提示icon
                    const warn_icon_inner = document.createElement('div');
                    const warn_icon = document.createElement('div');
                    warn_icon_inner.id = 'tal_heading-icon-fail-inner'
                    warn_icon.id = 'tal_heading-icon-fail'
                    warn_icon_inner.appendChild(warn_icon)

                    const tip_box = document.createElement('div');
                    tip_box.id = 'tal_tip-inner'

                    tip_box.appendChild(warn_icon_inner);
                    tip_box.appendChild(tip_s);
                    tip_box.appendChild(tip_w);
                    shadow_box.appendChild(tip_box);

                    return shadow_box;
                }

                //创建二维码失效-过期状态元素
                const createScanExpired = (onClickTh) => {
                    //创建蒙版
                    let shadowId = 'tal_retry';
                    if (document.getElementById(shadowId)) {
                        _util.removeElement(document.getElementById(shadowId));
                    }
                    const shadow_box = document.createElement('div');
                    shadow_box.id = shadowId;
                    //状态语
                    const tip_s = document.createElement('p');
                    tip_s.id = 'tal_heading-subtitle';
                    tip_s.innerHTML = "二维码已失效";
                    //提示警告语
                    const tip_w = document.createElement('a');
                    tip_w.id = 'tal_heading-subtitle-expired';
                    tip_w.onclick = onClickTh;
                    tip_w.innerHTML = '点击刷新';

                    const tip_box = document.createElement('div');
                    tip_box.id = 'tal_tip-inner'

                    tip_box.appendChild(tip_s);
                    tip_box.appendChild(tip_w);
                    shadow_box.appendChild(tip_box);

                    return shadow_box;
                }

                //创建二维码图片
                const createQRCode = (src) => {
                    const qrcodeImage = document.createElement('img');
                    qrcodeImage.id = 'tal_qrcode';
                    qrcodeImage.src = src;
                    return qrcodeImage;
                };

                //获取二维码接口请求失败
                const getQRCodeFail = (qrcodeElm) => {
                    qrcodeWrapper = document.createElement('div');
                    qrcodeWrapper.id = 'tal_qrcode-wrapper';

                    // 这里替换一个二维码假数据
                    const qrcodeImage = createQRCode('https://gblobscdn.gitbook.com/assets%2F-LdsKjoPVRBStTP-5zXe%2F-LxAQpSlzRkSs4UdaL4x%2F-LxARd7Blg5lxKDAJlH2%2Fimage.png?alt=media&token=216aaa82-4bd2-4b88-aa4e-bf9601ca9582');

                    qrcodeImage.onload = () => {
                        unloading();
                    };

                    const shadow = createScanFail(() => { startShow(2) });

                    qrcodeWrapper.appendChild(qrcodeImage);
                    qrcodeWrapper.appendChild(shadow);
                    qrcodeElm.appendChild(qrcodeWrapper);
                }
                startShow = (generate_type) => {
                    if (intervalNum) {
                        clearTimeout(intervalNum);
                    };
                    loading();
                    // 请求二维码
                    var setParams = {
                        image_type: 2,
                        generate_type: generate_type
                    },
                        getRouterUrl = _util.parseStr(window.location.href.split('?')[1]),
                        dev_flag = getRouterUrl.tal_passport_flag_20200420 || ''
                    if (dev_flag) {
                        setParams.dev_flag = dev_flag
                    }
                    _util.axiosGet(passport_host_v1 + '/web/login/qrcode/get', {
                        data: setParams,
                        success: function(res) {
                            if (res.errcode !== 0) {
                                //获取二维码接口信息失败回调
                                getQRCodeFail(qrcodeNode);
                                if (onQRCodeLoadFaild) {
                                    onQRCodeLoadFaild(res);
                                }
                            } else {
                                const { code_id, content } = res.data
                                if (onQRCodeLoad) {
                                    const qrcode = {
                                        code_id: code_id,
                                        content: content
                                    }
                                    // 二维码首次成功加载时回调  参数是二维码信息
                                    onQRCodeLoad(qrcode);
                                }
                                if (qrcodeNode) {
                                    qrcodeWrapper = document.createElement('div');
                                    qrcodeWrapper.id = 'tal_qrcode-wrapper';

                                    const qrcodeImage = createQRCode(content);
                                    qrcodeImage.onload = () => {
                                        unloading();
                                        if (onQRCodeShow) {
                                            onQRCodeShow();
                                        };
                                        // 用户同意授权-成功登录
                                        let decoOnSuccess = function(data) {
                                            if (successCallback && typeof successCallback === 'function') {
                                                successCallback(data)
                                            }
                                        };
                                        // 已扫码
                                        let decoOnScanned = function(data) {
                                            const shadow = createScanSuccess();
                                            qrcodeWrapper.appendChild(shadow);
                                            if (onScanned) {
                                                onScanned(data)
                                            }
                                        }
                                        // 已失效已过期
                                        let decoOnExpired = function() {
                                            const shadow = createScanExpired(() => { startShow(3) });
                                            qrcodeWrapper.appendChild(shadow);
                                            if (onExpired) {
                                                onExpired()
                                            }
                                        }
                                        // 用户取消授权
                                        let decoOnCancel = function(data) {
                                            const shadow = createScanExpired(() => { startShow(3) });
                                            qrcodeWrapper.appendChild(shadow);
                                            if (onCancel) {
                                                onCancel(data)
                                            }
                                        }
                                        // 获取二维码信息接口code！= 0失败
                                        let decoOnError = function(data) {
                                            const shadow = createScanFail(() => { startShow(2) });
                                            qrcodeWrapper.appendChild(shadow);
                                            if (onError) {
                                                onError(data)
                                            }
                                        }
                                        // 开始轮询二维码status
                                        _t.qrCodeStartPollingStatus({
                                            qrcodeId: code_id,
                                            onScanned: decoOnScanned,
                                            onExpired: decoOnExpired,
                                            successCallback: decoOnSuccess,
                                            onCancel: decoOnCancel,
                                            onError: decoOnError,
                                            setQrcodeStatus: ''
                                        });
                                    };
                                    qrcodeWrapper.appendChild(qrcodeImage);
                                    qrcodeNode.appendChild(qrcodeWrapper);
                                }
                            }
                        },
                        fail: function(err) {
                            //网络出错
                            getQRCodeFail(qrcodeNode);
                            if (onQRCodeLoadFaild) {
                                onQRCodeLoadFaild(err);
                            }
                        }
                    })
                }
                startShow(1);
            }
        }, 100)

    },
    /**
     * @name: authorizationInfo
     * @description: code值换取页面渲染绑定信息
     * @param {type} code校验信息
     * @return
    */
    authorizationInfo(params) {
        if (!_util.validResHeader()) return params.success(_util.getCode(1000000))
        var privateParams = getParams(params)
        _util.axiosGet(passport_host_v1 + '/web/authorization', privateParams)
    },

    /**
     * @name: authorizationConfirm
     * @description: 确认授权
     * @param {type} null
     * @return
    */
    authorizationConfirm(params) {
        if (!_util.validResHeader()) return params.success(_util.getCode(1000000))
        var privateParams = getParams(params)
        if (privateParams.data.is_second_verify != 1 && window.ALI_AWSC_INIT_NVC && typeof window.ALI_AWSC_INIT_NVC.getNVCVal === 'function') {
          // 非二次滑块验证，拼接无痕验证签名
          privateParams.data.invisible_sig = window.ALI_AWSC_INIT_NVC.getNVCVal()
        }
        _util.axiosPost(passport_host_v1 + '/web/authorization/confirm', privateParams)
    },
    /**
     * @name: getAuthCgList
     * @description: 业务平台获取授权登录的cg列表
     * @param {type} null
     * @return
    */
    getAuthCgList(params) {
        if (!_util.validResHeader()) return params.success(_util.getCode(1000000))
        // console.log(8888000)
        var privateParams = getParams(params)
        _util.axiosPost(passport_host_v1 + '/web/login/cg/list', privateParams)
    },
    /**
     * @name: getCaptcha
     * @description: 获取验证码/点击图片刷新验证码/点击看不清刷新
     * @param {type} type=1为首次获取验证码，为2为刷新验证码
     * @return
    */
    getCaptcha(type, params) {
        var captchaUrl = '',
            _this = this
        // 动态创建css
        if (!_util.isIncludeFile('captcha.css')) {
            var link = document.createElement('link')
            link.type = 'text/css'
            link.href = ucresHost + '/libs/jssdk/lib/captcha.css'
            link.rel = 'stylesheet'
            document.getElementsByTagName('head').item(0).appendChild(link)
        }
        var setParams = getParams(params)
        setParams.captchaParams.data.scene = setParams.sceneType
        var set_captchaParams = {
            data: setParams.captchaParams.data,
            success: (res) => {
                console.log(res)
                if (res.errcode == 0) {
                    captchaUrl = res.data.captcha
                    // 获取图形码成功后调用页面结构
                    if (type == 1) {
                        _this.showCaptcha(captchaUrl, params)
                    }
                    document.getElementById('tal-passport-captcha-pic').src = captchaUrl;
                } else if (res.errcode == 14106) {
                    // 不显示图形验证，直接接口通过
                    // 设置场景数据
                    var captchaData = {
                        requestType: 2
                    }
                    if (_this[params.captchaCallback]) {
                        _this[params.captchaCallback](params.captchaParams, captchaData)
                    }
                } else {
                    _this.showPassportToast(res.errmsg)
                }
            },
            fail: (err) => {
                console.log(err)
            }
        }
        // 判断是否需要登录态
        if (setParams.checkToken) {
          _this.asyncCheckLogin().then(function(res){
            _util.axiosPost(setParams.host + '/web/captcha/get', set_captchaParams, setParams.specialParams)
          }).catch(function(fail){
            // 未登录
            _this.showPassportToast(fail.errmsg)
          })
        } else {
          _util.axiosPost(setParams.host + '/web/captcha/get', set_captchaParams)
        }
    },
    /**
     * @name: showCaptcha
     * @description: 生成图形验证码弹窗
     * @param {type} null
     * @param {Object} captchaParams 请求图形验证码参数对象
     * @return
    */
    showCaptcha(captchaUrl, captchaParams) {
        var captchaUrl = captchaUrl,
            _this = this
        // 图形验证码页面结构
        var Captcha = `<div class="tal-passport-captcha" id="tal-passport-captcha">
                            <div class="tal-passport-captcha_content">
                                <div class="tal-passport-captcha_top">
                                    <span class="tal-passport-captcha_title">安全验证</span>
                                    <img id="tal-passport-captcha_close" class="tal-passport-captcha_close" src="`+ ucresHost + `/libs/jssdk/lib/img/location_nav_close_btn.png" />
                                </div>
                                <div class="tal-passport-captcha_middle">
                                    <div class='tal-passport-captcha_shape' id='tal-passport-captcha_shape'><img id="tal-passport-captcha-pic" src='`+ captchaUrl + `'/></div>
                                    <p  class='tal-passport-captcha_refresh' id='tal-passport-captcha_refresh'>看不清，<span>刷新</span></p>
                                </div>
                                <div class="tal-passport-captcha_bottom">
                                    <div class='tal-passport-captcha_fill'><input id="tal-passport-captcha-fill" placeholder="请输入验证码" maxlength="4" type='text'/></div>
                                    <button disabled="true" id="tal-passport-captcha-btn" class='tal-passport-captcha_submit'><img id="tal-passport-btn-loading" class='tal_passport_captcha_button_loading' style="display: none;" src="`+ ucresHost + `/libs/jssdk/lib/img/tal_button_loading.png"/><span class="tal_passport_captcha_button_submit">确定</span></button>
                                </div>
                            </div>
                            <div id="talPassportCaptchaMask" class="tal-passport-captcha_mask"></div>
                        </div>`;
        var captchaEle = document.createElement("div");
        captchaEle.innerHTML = Captcha;
        // 判断接入方是否配置将弹窗插入全局或者局部
        if (captchaContent == "") {
            // document.body.style.position = 'relative'
            document.body.appendChild(captchaEle)
        } else {
            document.getElementById(captchaContent).style.position = 'relative'
            document.getElementById(captchaContent).appendChild(captchaEle)
        }
        _util.addEvent(["input", "oninput"], document.getElementById('tal-passport-captcha-fill'), function(event) {
            _this.fillCaptcha(event)
        })
        _util.addEvent(["porpertychange", "onporpertychange"], document.getElementById('tal-passport-captcha-fill'), function(event) {
            _this.fillCaptcha(event)
        })
        document.getElementById('tal-passport-captcha-btn').onclick = function() {
            _this.submitCaptcha(captchaParams)
        }
        document.getElementById('tal-passport-captcha_shape').onclick = document.getElementById('tal-passport-captcha_refresh').onclick = function() {
            _this.getCaptcha(2, captchaParams)
        }
        document.getElementById('tal-passport-captcha_close').onclick = function() {
            _this.closeCaptcha(2, captchaParams)
        }
    },
    /**
      * @name: fillCaptcha
      * @description: 实时计算input输入内容
      * @param {type} null
      * @return
     */
    fillCaptcha(e) {
        var talPassportCaptchaFillValue = document.getElementById('tal-passport-captcha-fill').value
        if (talPassportCaptchaFillValue.length >= 4) {
            document.getElementById('tal-passport-captcha-btn').removeAttribute('disabled')
        } else {
            document.getElementById('tal-passport-btn-loading').style.display = 'none';
            document.getElementById('tal-passport-captcha-btn').setAttribute('disabled', true)
        }
    },
    /**
      * @name: submitCaptcha
      * @description: 提交验证码
      * @param {type} null
      * @return
     */
    submitCaptcha(params) {
        // 判断是否在请求中
        if (captchaLoding) return false
        captchaLoding = true
        var talPassportCaptchaFillValue = document.getElementById('tal-passport-captcha-fill').value,
            _this = this;
        document.getElementById('tal-passport-btn-loading').style.display = 'block'
        // 设置场景数据
        var captchaData = {
            requestType: 1,
            captchaVal: talPassportCaptchaFillValue || ''
        }
        if (_this[params.captchaCallback]) {
            _this[params.captchaCallback](params.captchaParams, captchaData)
        }
    },
    /**
     * @name: closeCaptcha
     * @description: 关闭验证码弹窗
     * @param {type} null
     * @return
    */
    closeCaptcha(type, params) {
        var talPassportCaptcha = document.getElementById('tal-passport-captcha');
        _util.removeElement(talPassportCaptcha)
        if (type == 1) return false
        if (params.captchaParams.closeCaptchaCallback && typeof params.captchaParams.closeCaptchaCallback == 'function') {
            params.captchaParams.closeCaptchaCallback()
        } else {
            window.location.reload()
        }
    },
    /**
     * @name: createToast
     * @description: toast弹窗
     * @param {msg} msg 弹窗提示内容
     * @return
    */
    showPassportToast(msg) {
        var toast = `<div id="talpassportToast" class="tal-passport-toast-wrap">
                        <div class="tal-passport-toast-inner">`+ msg + `</div>
                    </div>`;

        var toastEle = document.createElement("div");
        toastEle.innerHTML = toast;
        // 判断接入方是否配置将弹窗插入全局或者局部
        if (captchaContent == "") {
            document.body.appendChild(toastEle)
        } else {
            document.getElementById(captchaContent).appendChild(toastEle)
        }
        var talpassportToast = document.getElementById('talpassportToast');
        setTimeout(() => {
            _util.removeElement(talpassportToast)
        }, 2000)
    },
    /**
     * @name: successSubmitCaptcha
     * @description: 提交验证码完成后所需执行方法(清空输入框，提交按钮置灰)
     * @param {无}
     * @return
    */
    successSubmitCaptcha() {
        var talPassportCaptchaFill = document.getElementById('tal-passport-captcha-fill'), // 验证码输入框
            talPassportCaptchaBtn = document.getElementById('tal-passport-captcha-btn'); // 提交按钮

        talPassportCaptchaFill.value = ""
        talPassportCaptchaBtn.setAttribute('disabled', true)
    },
    /*
     * @discribe 滑块失败，调用图形验证处理逻辑方法
     * @method captchaSendFn
     * @param {Object} params 请求参数
     * @param {Object} requestData 请求数据信息
     * @param {Number} captchaData 图形验证场景的数据传参
     * */
    captchaSendFn(params, requestData, captchaData) {
        var _this = this
        // 判断是调出图形验证，还是校验图形验证码发送接口、还是不调用滑块也不校验接口发送，直接调用原接口发送
        if (captchaData.requestType && captchaData.requestType == 1) {
            // 校验图形验证码接口
            // 重置请求参数
            var setResetParams = {
                data: getParams(params).data || {},
                success: function(res) {
                    if (res.errcode == 14104 || res.errcode == 14105) {
                        // 图形验证码验证失败的回调，失败之后重新请求获取图形验证码，并且不执行业务方的成功回调

                        // toast提示错误信息
                        _this.showPassportToast(res.errmsg)
                        // 刷新验证码
                        _this.getCaptcha(2, {
                            captchaParams: getParams(params),
                            captchaCallback: requestData.requestName,
                            sceneType: requestData.sceneType,
                            host: requestData.host,
                            checkToken: requestData.checkToken,
                            specialParams: requestData.specialParams
                        })
                        // 清空输入框，并且提交按钮置灰
                        _this.successSubmitCaptcha()
                    } else {
                        // 调取传递的回调方法
                        params.success ? params.success(res) : function(res) { }
                    }
                },
                fail: function(fail) {
                    params.fail ? params.fail(fail) : function(fail) { }
                },
                complete: function(res) {
                    // 请求完成之后设置图形验证提交为可点击状态
                    captchaLoding = false
                    // loding图标消失
                    document.getElementById('tal-passport-btn-loading').style.display = 'none'
                    if (res.errcode == 14104 || res.errcode == 14105) return false
                    // 关闭弹层
                    _this.closeCaptcha(1)
                    params.complete ? params.complete(res) : function(res) { }
                }
            }
            setResetParams.data.captcha = captchaData.captchaVal || ''
            if (requestData.checkToken) {
              _util.axiosPost(requestData.host + requestData.requestUrl, setResetParams, requestData.specialParams)
            } else {
              _util.axiosPost(requestData.host + requestData.requestUrl, setResetParams)
            }
        } else if (captchaData.requestType && captchaData.requestType == 2) {
            // 滑块在白名单中，不出现滑块也不出现图形验证，直接调用原始接口通过
            if (requestData.checkToken) {
              _util.axiosPost(requestData.host + requestData.requestUrl, params, requestData.specialParams)
            } else {
              _util.axiosPost(requestData.host + requestData.requestUrl, params)
            }
        } else {
            // 调出图形验证，图形验证代替滑块，并且不发送接口请求
            var setCaptchaParams = {
                captchaParams: getParams(params),
                captchaCallback: requestData.requestName,
                sceneType: requestData.sceneType,
                host: requestData.host,
                checkToken: requestData.checkToken,
                specialParams: requestData.specialParams
            }
            console.log(setCaptchaParams, '-setCaptchaParams-----')
            // 生产环境可以注释掉滑块参数设置
            setCaptchaParams.captchaParams.data.invisible_sig = ''
            this.getCaptcha(1, setCaptchaParams)
        }
    },
    /*********************暴露axios************************/
    setPassportAxiosRequest(params){
      if(params.method=='GET' || params.method=='get') {
        _util.axiosGet(passport_host_v1 + params.url, params)
      }
        if(params.method=='POST' || params.method=='post'){
          _util.axiosPost(passport_host_v1 + params.url, params, params.requestHeaderArr, params.type, params.headersType)
        }
    },
    /*********************微信授权绑定登录开始************************/

    /*
    * @discribe 微信授权
    * @method weChatAuthorize
    * @param {string} params redirect_url 请求参数，重定向地址
    * */
    weChatAuthorize(params) {
        console.log(params, 'params')
        if (!_util.isCheckWeChat()) return params.fail('非微信环境')
        if (!_util.validResHeader()) return params.success(_util.getCode(1000000))
        var privateParams = getParams(params);
        if (!privateParams.data) {
            privateParams.data = { 'redirect_url': window.location.href }
        }
        if (!privateParams.data.redirect_url) {
            privateParams.data.redirect_url = window.location.href
        }
        _util.axiosPost(passport_host_v1 + '/web/wx/login/redirect', {
            data: privateParams.data || {},
            success: (res) => {
                if (res.errcode == 0) {
                    params.success ? params.success(res) : function(res) { }
                    if (res.data.url) {
                        __udc_ctx = res.data.ctx
                        window.location.href = res.data.url
                    }
                }else {
          params.fail(res)
        }
            },
            fail: (err) => {
                console.log(err)
            }
        })
    },
    /*
    * @discribe 检测微信授权回调后的参数
    * @method checkWeChatParams
    * @param {string} params redirect_url 请求参数，重定向地址
    * */
    checkWeChatParams(params) {
        console.log(params, 'params00000000')
        var urlParams = _util.getUrlParmas(window.location.href);
        var __udc_ctx = urlParams.__udc_ctx;
        var __udc__wx = urlParams.__udc__wx;
        __udc_ctx = urlParams.__udc_ctx;
        // 如果code值不存在或者非微信环境，不用处理
        if (!__udc__wx || !_util.isCheckWeChat()) return
        if (__udc__wx == 'login') {
            // 直接登录
            this.weChatDirectLogin(params)
        } else if (__udc__wx == 'recommend') {
            // 推荐登录
            this.recommendLogin(params)
        } else if (__udc__wx == 'phone') {
            console.log(params, '手机号登录')
            params.success({
                errcode: 0,
                errmsg: '请求成功',
                data: {
                    "__udc__wx": 'phone'
                }
            });
        }
    },
    /*
    * @discribe 直接登录
    * @method weChatDirectLogin
    * @param {string} params redirect_url 请求参数，重定向地址
    * */
    weChatDirectLogin(params) {
        console.log(params, '直接登录')
        if (!_util.validResHeader()) return params.success(_util.getCode(1000000))
        var privateParams = getParams(params);
        var urlParams = _util.getUrlParmas(window.location.href);
        if (urlParams.__udc_ctx) {
            __udc_ctx = urlParams.__udc_ctx;
        }
        if (!privateParams.data) {
            privateParams['data'] = { 'ctx': __udc_ctx || '' }
        } else {
            privateParams.data['ctx'] = __udc_ctx || ''
        }
        _util.axiosPost(passport_host_v1 + '/web/wx/login', privateParams)
        // _util.axiosPost(passport_host_v1 + '/web/phonecode/get', privateParams)
    },
    /*
    * @discribe 推荐登录获取参数
    * @method recommendLogin
    * @param {string} params redirect_url 请求参数，重定向地址
    * */
    recommendLogin(params) {
        console.log(params, '推荐登录')
        // 暴露tal_id、phone、wx_official_account
        if (!_util.validResHeader()) return params.success(_util.getCode(1000000))
        var privateParams = getParams(params);
        var urlParams = _util.getUrlParmas(window.location.href);
        if (urlParams.__udc_ctx) {
            __udc_ctx = urlParams.__udc_ctx;
        }
        if (!privateParams.data) {
            privateParams['data'] = { 'ctx': __udc_ctx || '' }
        } else {
            privateParams.data['ctx'] = __udc_ctx || ''
        }
        _util.axiosPost(passport_host_v1 + '/web/wx/login/recommend', privateParams)
    },
    /*********************微信授权绑定登录结束************************/

    /*
    * @discribe 设置实名认证接口
    * @param {params} 参数
    * */
    setCredIdentify: function(params) {
      if (!_util.validResHeader()) return (params.success ? params.success(_util.getCode(1000000)) : '')
      var privateParams = getParams(params)
      this.asyncCheckLogin().then(function(res){
        var setSpecialParams = {
          isCheckLogin: true,
          name: 'setCredIdentify'
        }
        _util.axiosPost(cg_host_v1 + '/web/user/cred/identify', privateParams, setSpecialParams)
      }).catch(function(fail){
        // 未登录，接口返回什么就是什么，原封不动返回给业务方
        if (fail.errcode) {
          params.success ? params.success(fail) : function (fail) {}
        } else {
          params.fail ? params.fail(fail) : function (fail) {}
        }
        params.complete ? params.complete(fail) : function (fail) {}
      })
    }

}
// Allow use of default import syntax in TypeScript
export default TAL_UC;



// WEBPACK FOOTER //
// ./src/index.js